import { z } from 'zod'
import { oc } from '@orpc/contract'

export const facilitySearch = oc
  .route({ method: 'GET', path: '/v2/facility' })
  .input(
    z.object({
      query: z.string().optional(),
      // 'tagged' (default) = only facilities added to the records-request
      // directory (marker tag, plus legacy records-facility typed orgs).
      // 'all' = every Organization on the platform (labs, rads, care orgs, …)
      // — used by the add-facility form to dedupe before creating; requires
      // a non-empty query.
      scope: z.enum(['tagged', 'all']).optional(),
    }),
  )
  .output(
    z.object({
      facilities: z.array(
        z.object({
          id: z.string(),
          name: z.string(),
          street: z.string().optional(),
          city: z.string().optional(),
          state: z.string().optional(),
          zip: z.string().optional(),
          fax: z.string().optional(),
          phone: z.string().optional(),
          // Already part of the records-request directory.
          tagged: z.boolean(),
        }),
      ),
    }),
  )
